import { getEnvVariables } from '@/env/getEnvVariables';
import axiosCore from 'axios';
import { safeSerializeError } from '@/utils/errorReporter';

export const isTokenExpired = (error: unknown): boolean => {
  if (!error) return false;
  const errorString = safeSerializeError(error);
  return (
    errorString.includes('TokenExpiredError') ||
    errorString.includes('token_expired') ||
    errorString.includes('AADB2C90077') ||
    errorString.includes('AADB2C90080')
  );
};

export const isInvalidGrant = (error: unknown): boolean => {
  if (!error) return false;
  const errorString = safeSerializeError(error);
  return (
    errorString.includes('invalid_grant') ||
    errorString.includes('AADB2C90088') ||
    errorString.includes('AADB2C90129')
  );
};

export const axios = axiosCore.create({
  baseURL: getEnvVariables().backendUri,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  xsrfHeaderName: 'X-XSRF-TOKEN',
  withCredentials: false,
  timeout: globalThis.location.hostname.includes('ipractice-test') ? 50000 : 10000, // acceptance is way too slow
});
